<template>
  <modal
    :open="open"
    @save="save()"
    @cancel="cancel()"
  >
    <div class="assignment-top">
      <h3>
        {{ $t(`ui.modals.${title}`) }}
      </h3>
      <p>
        {{ $t(`ui.modals.${subtitle}`) }}
      </p>
    </div>
    <div class="assignment-content">
      <assignment-modal-search-bar
        @search="search"
        :placeholder="searchPlaceholder"
        :shouldFocus="shouldFocusSearchbar"
        @shouldFocusChange="setShouldFocus"
      />
      <assignment-modal-element
        v-for="element in filteredCollection"
        :key="element"
        :item="element"
        :displayName="displayName"
        :assignedCollection="internalAssignedCollection"
        @input="assign"
      />
    </div>
  </modal>
</template>
<script>
import Modal from '@/components/helpers/Layout/NewModal'
import AssignmentModalElement from '@/components/layouts/partials/AssignmentModalElement'
import AssignmentModalSearchBar from '@/components/layouts/partials/AssignmentModalSearchBar'

export default {
  props: {
    // Which attribute to use as label
    displayName: {
      type: String,
      default: 'name'
    },
    searchPlaceholder: {
      type: String,
      required: true
    },
    collection: {
      type: Array,
      required: true
    },
    assignedCollection: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AssignmentModalSearchBar,
    Modal,
    AssignmentModalElement
  },
  data() {
    return {
      // Copy assignedCollection so we can alter it and only save
      // when save is clicked
      internalAssignedCollection: _.clone(this.assignedCollection),
      filteredCollection: [],
      shouldFocusSearchbar: false
    }
  },
  mounted() {
    this.resetFilteredCollection()
  },
  methods: {
    setShouldFocus() {
      this.shouldFocusSearchbar = false
    },
    search(term) {
      if (term) {
        let searchCollection = this.collection.filter(item => item[this.displayName].toLowerCase().includes(term.toLowerCase()))
        this.filteredCollection = searchCollection
      } else {
        this.resetFilteredCollection()
      }
    },
    resetFilteredCollection() {
      this.filteredCollection = this.collection
    },
    assign(item, val) {
      if (val) {
        if (!this.internalAssignedCollection.includes(item)) {
          this.internalAssignedCollection.push(item)
        }
      } else {
        if (this.internalAssignedCollection.includes(item)) {
          let idx = this.internalAssignedCollection.indexOf(item)
          this.internalAssignedCollection.splice(idx, 1)
        }
      }
      this.shouldFocusSearchbar = true
    },
    save() {
      this.$emit('save', this.internalAssignedCollection)
    },
    resetInternalCollection() {
      // Clone so that we don't get the listeners
      this.internalAssignedCollection = _.clone(this.assignedCollection)
    },
    cancel() {
      this.resetInternalCollection()
      this.$emit('close')
    }
  },
  watch: {
    assignedCollection() {
      this.resetInternalCollection()
    },
    open(val) {
      // If it switched to open reset the collection
      if (val) {
        this.resetFilteredCollection()
      }
    }
  }
}
</script>
<style lang="sass">
.assignment-content
  height: 30vh
  .field--wrapper .field--checkbox label
    margin-top: 0 !important
.assignment-top
  h3
    margin-top: 0
    margin-bottom: 20px
  p
    font-weight: 100

</style>



// WEBPACK FOOTER //
// AssignmentModal.vue?7729d071